import styled from "styled-components";

export const Styles = styled.section`
   body,
  a,
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  ul,
  li,
  ol,
 div,
 span {
  
  font-family: "GESSTWO" !important;
  
}
  min-height: 100vh;
  padding: 120px 24px 80px;
  background: linear-gradient(135deg, #031d17 0%, #02100d 100%);
  color: #f7fbff;

  .page-header {
    max-width: 960px;
    margin: 0 auto 32px;
    display: flex;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    align-items: center;
  }

  h1 {
    margin: 0;
    font-size: 2rem;
    color: var(--secondary-color);
  }

  .page-header p {
    margin: 8px 0 0;
    color: rgba(255, 255, 255, 0.75);
  }

  .page-header button {
    border: none;
    border-radius: 999px;
    padding: 12px 28px;
    font-weight: 600;
    background: linear-gradient(
      135deg,
      var(--secondary-color),
      rgba(21, 96, 87, 0.95)
    );
    color: #fff;
    cursor: pointer;
    transition: opacity 0.2s ease, transform 0.2s ease;
  }

  .page-header button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  .page-header button:not(:disabled):hover {
    transform: translateY(-1px);
  }

  .error-message {
    max-width: 960px;
    margin: 0 auto 16px;
    padding: 12px 18px;
    border-radius: 14px;
    background: rgba(255, 99, 104, 0.12);
    color: #ffb6b9;
  }

  .table-wrapper {
    max-width: 960px;
    margin: 0 auto;
    background: rgba(1, 51, 46, 0.85);
    border-radius: 24px;
    border: 1px solid rgba(201, 173, 110, 0.2);
    overflow: hidden;
    box-shadow: 0 25px 60px rgba(0, 0, 0, 0.35);
  }

  table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
  }

  thead {
    background: rgba(21, 96, 87, 0.8);
  }

  th {
    padding: 16px 12px;
    font-weight: 600;
    font-size: 0.95rem;
    color: #f9f2e8;
  }

  td {
    padding: 14px 12px;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    color: rgba(255, 255, 255, 0.85);
  }

  tbody tr:nth-child(even) {
    background: rgba(1, 42, 37, 0.4);
  }

  .loading-cell,
  .empty-cell {
    padding: 40px 12px;
    color: rgba(255, 255, 255, 0.7);
    font-style: italic;
  }

  @media (max-width: 640px) {
    .page-header {
      flex-direction: column;
      align-items: flex-start;
    }

    .page-header button {
      width: 100%;
      text-align: center;
    }

    th,
    td {
      font-size: 0.85rem;
      padding: 12px 8px;
    }
  }
`;
